<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="relative w-full h-screen flex items-center justify-start">
    <!-- Image as the background with <img> tag -->
    <img
      src="@/../img/home/health-care-bg.jpg"
      alt="Background"
      class="absolute w-full h-full object-cover rounded-lg shadow-lg"
    />
    <!-- Black Overlay covering full screen -->
    <div class="absolute inset-0 bg-black bg-opacity-80"></div>

    <!-- Content Box (Left-Aligned & Full Height) -->
    <div
      class="section-container relative z-10 flex flex-col justify-center items-start w-full text-left text-white h-full px-10"
    >
      <h1
        class="text-4xl md:text-5xl text-white"
      >{{ $t('Zorgblik: Kwaliteit van leven verbeteren') }}</h1>
      <p
        class="mt-5 text-xl font-semibold text-white"
      >{{ $t('Zorgblik is een bemiddelings- en uitzendbureau gespecialiseerd in 24-uurs zorg voor mensen met een verstandelijke beperking of psychiatrische problematiek') }}</p>
    </div>
  </div>
</template>

 